import { DataResult } from '@/utils/mockUtils'
export default {
  getHomePageSetting: () => {
    const data = {
      bannerImg: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
      bannerLink: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
      modules: [{
        categoryId: 3653
      },
      {
        categoryId: 3654
      },{
        categoryId: 36533
      },
      {
        categoryId: 3653
      }]
    }
    return DataResult.getSuccessResponse(data)
  },
  getInsidePageSetting: () => {
    const data = {
      bannerImg: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
      bannerLink: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
      quickLink: [{
        categoryId: 3653,
        categoryName: '新品播报类'
      },
      {
        categoryId: 3654
      },{
        categoryId: 36533
      },
      {
        categoryId: 3653
      }]
    }
    return DataResult.getSuccessResponse(data)
  }
}